/* eslint max-len: ["error", { "code": 120, "tabWidth": 4 }] */
/* eslint-disable node/no-unsupported-features */
import * as types from '../constants/ActionTypes';
import {Utils} from '../components/Utils';

export const getPost = (id) => ({
    type: types.REQUEST_POST,
    id,
});

export const receivePost = (post) => ({
    type: types.RECEIVE_POST,
    post,
});

export const errorPost = () => ({
    type: types.ERROR_POST,
});

export function fetchPost(id) {
    return function(dispatch, getState) {
        if (getState().post.items[id] !== undefined) {
            return;
        }

        dispatch(getPost(id));

        let dataURL = Utils.apiUrlWP() + '/wp-json/wp/v2/posts/' + id;
        return fetch(dataURL)
            .then(
                (response) => response.json(),
                (error) => {
                    throw new TypeError(error);
                }
            )
            .then((post) =>
                dispatch(receivePost(post))
            )
            .catch((error) => {
                    Utils.errobj('ACTIONS', 'fetchAbout', error);
                    dispatch(errorPost());
                }
            );
    };
}



// WEBPACK FOOTER //
// ./src/actions/post.js